<div class="page d-flex flex-column" *ngIf="stepInfo let stepInfo">
    <div class="toolbar">
        <div class="nuvei-app-container d-flex justify-content-between align-items-center h-100">
            <div class="d-flex align-items-center h-100">
                <img class="logo" src="../../../assets/logo.svg" routerLink="/lobby">
                <h4 class="business-name">{{ businessName }}</h4>
            </div>
            <img class="logo" src="../../../assets/nuvei_logo.svg">
        </div>
    </div>
    <ng-container *ngIf="!isMobile else mobile">
        <div class="nuvei-app-container nav-buttons">
            <app-icon width="40px" height="40px" class="se-icon-button" src="back"
                      [style]="(step === 0 || form.status !== 'created') ? 'visibility: hidden; pointer-events: none' : ''"
                      (click)="back()"
            ></app-icon>
            <div class="step-title flex-fill">
                <h2>{{ stepInfo.title }}</h2>
                <h4 *ngIf="step === 4">Historical or Expected</h4>
            </div>
            <app-icon width="40px" height="40px" class="se-icon-button" src="close" (click)="close()"></app-icon>
        </div>
        <div class="nuvei-app-container" *ngIf="(progress$ | async) let progress else noProgress">
            <progress class="w-100" *ngIf="progress < 100 else noProgress" [value]="(progress$ | async)" [max]="100"></progress>
        </div>
        <ng-template #noProgress>
            <div style="min-height: 16px"></div>
        </ng-template>
        <div class="nuvei-app-container step-summary" [class.warn]="summeryWarn" *ngIf="stepInfo.summary">
            <p>{{ stepInfo.summary }}</p>
        </div>

        <div class="nuvei-app-container flex-fill mb--16" [ngSwitch]="step">
            <app-nuvei-application-documents *ngSwitchCase="0"
                                             [uploadedFiles]="uploadedFiles"
                                             [missingDocuments]="missingDocuments"
                                             [progress]="(progress$ | async)!"
                                             (onFilesUpload)="onFilesChange($event)"
                                             (nextClick)="$event ? skipDocuments() : nextStep()"
            ></app-nuvei-application-documents>
            <app-nuvei-application-legal *ngSwitchCase="1"
                                         (formUpdate)="updateForm('legalForm')"
                                         (nextClick)="nextStep()"
                                         [form]="legalForm"
                                         [progress]="(progress$ | async)!"
            ></app-nuvei-application-legal>
            <app-nuvei-application-dba *ngSwitchCase="2"
                                       (formUpdate)="updateForm('dbaForm')"
                                       (nextClick)="nextStep()"
                                       [form]="dbaForm"
                                       [legalForm]="legalForm"
                                       [progress]="(progress$ | async)!"
            ></app-nuvei-application-dba>
            <app-nuvei-application-additional *ngSwitchCase="3"
                                              (formUpdate)="updateForm('additionalBusinessInfoForm')"
                                              (nextClick)="nextStep()"
                                              [form]="additionalBusinessInfoForm"
                                              [progress]="(progress$ | async)!"
            ></app-nuvei-application-additional>
            <app-nuvei-application-sales-profile *ngSwitchCase="4"
                                                 (formUpdate)="updateForm('salesProfileForm')"
                                                 (nextClick)="nextStep()"
                                                 [form]="salesProfileForm"
                                                 [progress]="(progress$ | async)!"
            ></app-nuvei-application-sales-profile>
            <app-nuvei-application-owners *ngSwitchCase="5"
                                          (formUpdate)="updateForm('businessOwnersForm')"
                                          (nextClick)="nextStep()"
                                          (addOwner)="addOwner()"
                                          [form]="businessOwnersForm"
                                          [progress]="(progress$ | async)!"
            ></app-nuvei-application-owners>
            <app-nuvei-application-bank *ngSwitchCase="6"
                                        (formUpdate)="updateForm('bankInformationForm')"
                                        (nextClick)="nextStep()"
                                        [form]="bankInformationForm"
                                        [progress]="(progress$ | async)!"
            ></app-nuvei-application-bank>
            <app-nuvei-application-summary *ngSwitchCase="7"
                                           [files]="uploadedFiles"
                                           [currentSignatures]="form.signatures"
                                           [legalForm]="legalForm.value"
                                           [dbaForm]="dbaForm.value"
                                           [additionalBusinessInfoForm]="additionalBusinessInfoForm.value"
                                           [salesProfileForm]="salesProfileForm.value"
                                           [businessOwnersForm]="businessOwnersForm.value"
                                           [bankInformationForm]="bankInformationForm.value"
                                           (updateFormDocumentUrl)="onFormDocumentUrlUpdate($event)"
                                           (onSignatureRevoke)="revokeOwnerSignature($event)"
                                           (goToStep)="step = $event"
                                           (handleFormErrors)="handleFormErrors($event)"
                                           (checkServerDataMismatch)="checkServerDataMismatch()"
            ></app-nuvei-application-summary>
            <app-nuvei-application-preview *ngSwitchCase="8"
                                           [formDocument]="form.formDocument"
                                           [applicationStatus]="form.status"
                                           [requiresGuarantorSignature]="businessOwnersForm.value.guarantor !== 0"
                                           [signatures]="form.signatures"
                                           [submitting]="submittingDocument"
                                           (submitApplication)="submit()"
                                           (onSignatureRevoke)="revokeOwnerSignature($event)"
            ></app-nuvei-application-preview>
        </div>
    </ng-container>
</div>

<ng-template #mobile>
    <div class="flex-fill d-flex flex-column justify-content-center align-items-center gap--32">
        <p class="mobile-message">
            To ensure the best user experience, the payment application form is available only on desktop and tablet devices for a seamless and secure process. However, all other application features remain fully accessible on mobile.
        </p>
        <button mat-flat-button color="primary" routerLink="/lobby">Close</button>
    </div>
</ng-template>